import React from 'react'
import InvcItem from './InvcItem'
import AddInvcForm from './AddInvcForm'
import moment from 'moment'

export default class InvcList extends React.Component {

  state = {adding:false}

  startAdd = () => {
    this.setState({adding:true});
  }

  cancelAdd = () => {
    this.setState({adding:false});
  }

  render() {

    const { requs, invcs, order, addInvc, editInvc } = this.props;

    const activeData = invcs.filter(el => {
      if(el.invc_active === 1){
        return true;
      }
      return false;
    });

    const mappedData = activeData.map( (el,num) => {
      return <InvcItem
        editInvc={editInvc}
        num={num}
        order={order}
        key={el.invc_id}
        invc={el}
        requs={requs}
      />
    });

    const addInvcForm = (this.state.adding) ?
      <AddInvcForm
        addInvc={addInvc}
        order={order}
        data={{
          invc_order_id: order.order_id,
          invc_requ_id: 0,
          invc_sum: 0,
          invc_billed: moment().format('Y-MM-DD'),
          invc_text: "",
          invc_active: 1,
          invc_inv: 1,
          invc_act: 1
        }}
        requs={requs}
        cancelAdd={this.cancelAdd}
      /> :
      <tr onClick={this.startAdd} >
        <td></td>
        <td><u>Нажмите, чтобы добавить счет</u></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>;

    return (
      <table className="table">
        <thead>
          <tr>
            <th>№</th>
            <th className="col-sm-5">Текст услуги</th>
            <th className="col-sm-1 text-right">Сумма</th>
            <th className="col-sm-2 text-right">Выставлен</th>
            <th className="col-sm-2">Реквизиты</th>
            <th className="col-sm-1 text-right">Счет/Акт</th>
            <th className="col-sm-1 text-right">№/Год</th>
          </tr>
        </thead>
        <tbody>
          {mappedData}
          {addInvcForm}
        </tbody>
      </table>
    )

  }
}



// WEBPACK FOOTER //
// ./src/components/invc/InvcList.js